/* eslint-disable no-param-reassign */
import { Transforms, Path, Node } from 'slate';
import { createParagraph } from '../utils/paragraph';
import { EmbedBlockFormat } from '../types';

const EMBED_TYPES = Object.values(EmbedBlockFormat);

export const withEmbeds = (editor: any) => {
	const { isVoid, insertBreak } = editor;

	editor.isVoid = (element: any) => (EMBED_TYPES.includes(element.type) ? true : isVoid(element));

	editor.insertBreak = (...args: any) => {
		const parentPath = Path.parent(editor.selection.focus.path);
		const parentNode = Node.get(editor, parentPath);
		if (editor.isVoid(parentNode)) {
			const nextPath = Path.next(parentPath);
			Transforms.insertNodes(editor, createParagraph(''), {
				at: nextPath,
				select: true,
			});
		} else {
			insertBreak(...args);
		}
	};

	return editor;
};
